import actions from '../../actionTypes';

export default user => {
  return {
    type: actions.ADD_USER,
    user
  };
};



// WEBPACK FOOTER //
// ./src/reducers/users/actions/addUser.js